import React from 'react'

import Container from '../../app-user-profile-container/default'

const index = () => {
  return <Container>XXXX</Container>
}

export default index
